import VueConfettiExplosion from 'vue-confetti-explosion';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    VueConfettiExplosion /*{
    directive: 'confetti',
    component: 'confetti', // => <tippy/>
    componentSingleton: 'confetti-singleton', // => <tippy-singleton/>,
    defaultProps: {
      placement: 'auto-end',
      allowHTML: true,
    }, // => Global default options * see all props
  }*/
  );
});
